/* eslint-disable max-len */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./ns-brand-content.html";

/**
 * <h4>**Candidate for Refactor**</h4>
 * <p>This component generates brand-story sections with media and text content. Used in ns-brand-story</p>
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-brand-content></ns-brand-content>
 *   </template>
 * </demo-snippet>
 *
 * <marked-element>
 *  <div slot="markdown-html">
 *  <script type="text/markdown">
 *
 *      ### Slot
 *
 *      ##### `<ns-brand-content>` provides the following slots for content:
 *
 *      Custom property            | Description                                       | Default
 *      --------------------------- |---------------------------------------------------|-------------------
 *      `brand-description`         | Override description header and description text  | `h3 desc header, and p desc text`
 *      `brand-link`                | Override CTA brand link                           | `ns-expressive-link`
 *
 *  </script>
 * </marked-element>
 */
export class NsBrandContent extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
    this._init();
  }

  static get is() {
    return "ns-brand-content";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * The header for the text portion of the content
       */
      descriptionHeader: {
        type: String,
        value: "Sample Header"
      },
      /**
       * The body of the text portion of the content
       */
      descriptionText: {
        type: String,
        value: "Some sample text for the body of brand content"
      },
      /**
       * An image that displays next to the text on desktop
       */
      desktopImage: {
        type: String,
        value:
          "https://test.nuskin.com/content/dam/brand-refresh/Lifestyle2.png"
      },
      /**
       * An image that displays in a landscape orientation next to the text on mobile
       */
      horizontalMobileImage: {
        type: String,
        value:
          "https://test.nuskin.com/content/dam/brand-refresh/Lifestyle1.png"
      },
      /**
       * An image that displays in a portrait orientation next to the text on mobile
       */
      verticalMobileImage: {
        type: String,
        value:
          "https://test.nuskin.com/content/dam/brand-refresh/Lifestyle3.png"
      },
      /**
       * Where to send the user when they click the CTA
       */
      ctaLink: {
        type: String,
        value: "www.nuskin.com"
      },
      /**
       * The text of the CTA
       */
      ctaText: {
        type: String,
        value: "Sample CTA"
      },
      // videoUrl: String,
      // videoLinkText: String,
      /**
       * mediaAlignment determines if the content section's media is right or left aligned on initial load.
       */
      mediaAlignment: {
        type: String,
        value: "right",
        reflectToAttribute: true
      },
      /**
       * Alt text for the Hero Image
       */
      imageAltText: {
        type: String,
        value: "Image Alt Text"
      },
      activeImage: {
        type: String
      }
    };
  }

  /**
   * Calls all initial setup methods.
   * @private
   */
  _init() {
    this._initImages();
  }

  /**
   * Sets the background image variables for the different breakpoints.
   * @private
   */
  _initImages() {
    if (window.innerWidth >= 1024) {
      this.activeImage = this.desktopImage;
    }
    if (window.innerWidth >= 768 && window.innerWidth < 1024) {
      this.activeImage = this.verticalMobileImage;
    }
    if (window.innerWidth < 768) {
      this.activeImage = this.horizontalMobileImage;
    }
  }
}

customElements.define(NsBrandContent.is, NsBrandContent);
